import Empty from 'constants/empty';
import Storage from 'utils/localStorage/Storage';
import dateUtils from 'utils/Date';

const TWENTY_FOUR_HOURS_IN_MILLISECONDS = 86400000;
const P13N_DATA = 'P13N_DATA';

const createCacheKeyPrefix = () => {
    const { country, language } = Sephora.renderQueryParams;

    return `${P13N_DATA}_${country}-${language}`;
};

const setPersonalizationKey = function (context) {
    return `${createCacheKeyPrefix()}_${context}`;
};

const setPersonalizationCache = function (data) {
    data?.forEach(item => {
        const key = setPersonalizationKey(item?.p13n?.context);
        const oneDay = new Date().getTime() + TWENTY_FOUR_HOURS_IN_MILLISECONDS;
        const endDate = item.p13n?.endDate && new Date(item?.p13n?.endDate).getTime();
        const expireDate = endDate < oneDay ? item?.p13n?.endDate : TWENTY_FOUR_HOURS_IN_MILLISECONDS;

        const expiry = item?.p13n?.isAbTest ? item?.p13n?.abTestEndDate : expireDate;

        if (!Storage.local.getItem(key, false, true)) {
            Storage.local.setItem(key, item, expiry);
        }
    });
};

const setPersonalizationPlaceholder = context => {
    const key = setPersonalizationKey(context);

    if (!Storage.local.getItem(key, false, true)) {
        Storage.local.setItem(key, { context }, TWENTY_FOUR_HOURS_IN_MILLISECONDS);
    }
};

const getAllPersonalizedCache = function () {
    const cachedData = [];
    const cacheKeyPrefix = createCacheKeyPrefix();
    Object.keys(localStorage)
        .filter(key => key.startsWith(cacheKeyPrefix))
        .forEach(key => {
            const cache = Storage.local.getItem(key, false, true);

            if (cache) {
                cachedData.push(cache);
            }
        });

    return cachedData;
};

const filteredCache = function (personalization) {
    if (!personalization) {
        return null;
    }

    let contextToReturn;
    const cachedData = getAllPersonalizedCache();
    const cachedItem = cachedData.filter(data => data.context === personalization.context)?.[0];

    if (cachedItem) {
        if (cachedItem.p13n?.abTestId && personalization.activeAbTestIds?.indexOf(cachedItem.p13n.abTestId) === -1) {
            contextToReturn = personalization.context;
        }
    } else {
        contextToReturn = personalization.context;
    }

    if (contextToReturn) {
        Storage.local.removeItem(setPersonalizationKey(contextToReturn));
    }

    return contextToReturn;
};

const getContextIdsToUpdate = items =>
    items.reduce((contextIds, item) => {
        if (item.personalization && item.personalization.isEnabled && !dateUtils.isDataExpired(item.personalization?.endDate)) {
            const filteredItem = filteredCache(item.personalization);

            if (filteredItem) {
                contextIds.push(item.personalization.context);
            }
        }

        (item.items || Empty.Array)
            .filter(
                ({ personalization }) =>
                    personalization && personalization.isEnabled && personalization.context && !dateUtils.isDataExpired(personalization.endDate)
            )
            .forEach(childItem => {
                const contextId = filteredCache(childItem.personalization);

                if (contextId) {
                    contextIds.push(contextId);
                }
            });

        return contextIds;
    }, []);

const getPersonalizationCache = function (context) {
    return Storage.local.getItem(setPersonalizationKey(context));
};

export default {
    getContextIdsToUpdate,
    setPersonalizationCache,
    setPersonalizationKey,
    getPersonalizationCache,
    filteredCache,
    getAllPersonalizedCache,
    setPersonalizationPlaceholder
};
